import { createNavItem, ODIcons, ODSiteNav } from '@mdpp/od-react-belt'
import { SiteUrls } from '../SiteUrls'

export const PharmacySiteNavs: ODSiteNav = {
  items: [
    createNavItem(ODIcons.SVGDashBoard, `조제현황`, SiteUrls.Pharmacy.Reservation.Main),
    createNavItem(ODIcons.SVGMyPage, `마이페이지`, SiteUrls.Pharmacy.MyPage.Main),
  ],
}
